import React, { useEffect, useState } from "react";

import estilo from "../styles/Animes.module.css";
import Tarjeta from "../components/Tarjeta";
import supabase from "../config/supabaseCliente";

function Animes() {
  const [items, setItems] = useState([]);
  const [pagina, setPagina] = useState(17);

  const [genero, setGenero] = useState();
  const [traer, setTraer] = useState(false);

  let generos = [
    "Acción",
    "Aventura",
    "Colegial",
    "Comedia",
    "Deportes",
    "Ecchi",
    "Fantasía",
    "Harem",
    "Isekai",
    "Magia",
    "Militar",
    "Romance",
    "Shounen",
    "Sobrenatural",
    "Vampiros",
  ];

  function cambiar(e) {
    setTraer(false);
    setGenero(e.target.value);
  }

  function todos() {
    setPagina(17);
    setTraer(true);
    setGenero("");
  }

  const handleScroll = () => {
    if (
      window.innerHeight + document.documentElement.scrollTop ===
      document.documentElement.offsetHeight
    ) {
      setPagina(pagina + 6);
    }
  };

  useEffect(() => {
    const fetchLista = async () => {
      if (traer) {
        const { data, error } = await supabase
          .from("anime")
          .select()
          .order("id", { ascending: false })
          .range(0, pagina);

        if (error) {
          console.log("Error", error);
        }

        if (data) {
          setItems(data);
          console.log(data);
        }
      } else {
        const { data, error } = await supabase
          .from("anime")
          .select()
          .order("id", { ascending: false })
          .contains("generos", JSON.stringify([{ genero: genero }]))
          .range(0, pagina);

        if (error) {
          console.log("Error", error);
        }

        if (data) {
          setItems(data);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    fetchLista();
  }, [pagina, genero]);

  const images = [
    {
      src: "https://via.placeholder.com/350x150",
      link: "https://www.example.com/1",
      nombre: "image1",
    },
    {
      src: "https://via.placeholder.com/350x150",
      link: "https://www.example.com/2",
      nombre: "image2",
    },
    {
      src: "https://via.placeholder.com/350x150",
      link: "https://www.example.com/3",
      nombre: "image3",
    },
    {
      src: "https://via.placeholder.com/350x150",
      link: "https://www.example.com/4",
      nombre: "image4",
    },
  ];
  console.log(images[images.length - 1]);
  return (
    <div>
      <div className={estilo.menu}>
        <div>
          <h2>Lista de Animes</h2>
        </div>

        <div className={estilo.generos}>
          <div className={estilo.nombre}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="22"
              height="22"
              fill="currentColor"
              viewBox="0 0 16 16"
            >
              <path d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5zm-3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
            </svg>
            <p>Generos</p>
          </div>

          <div className={estilo.botones}>
            <div className={estilo.botones_flex}>
              <button
                onClick={todos}
                className={traer ? `${estilo.activo}` : ""}
              >
                Todos
              </button>
              {generos.sort().map((e, i) => (
                <button key={i} onClick={cambiar} value={e}>
                  {e}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className={estilo.animes_tarjetas}>
        {items && items.map((e) => <Tarjeta key={e.id} ultimos={e}></Tarjeta>)}
      </div>
    </div>
  );
}

export default Animes;
